import React from 'react';
import ErrorImage from './../../images/404_Not-Found.svg';

const NotFound = () => {
  return (
    <div className='not-found'>
      <h1>Nicht gefunden</h1>

      <p>
        Leider existiert diese Seite nicht. Bitte wählen Sie eine andere Seite oder kontaktieren Sie uns über unsere
        Kontaktmöglichkeiten
      </p>

      <img
        className='image'
        src={ErrorImage}
        alt='Schwarzer Stempel mit rotem Notarsigel und der Aufschrift: 404 Error'
      />
    </div>
  );
};

export default NotFound;
